export default __webpack_public_path__ + "static/media/ponozky_konfety.6522c374.jpg";